<template>
<el-container id="home-main">
  <div>
    <publicHeader @hotelLanguage="hotelLanguage"></publicHeader>
    <div class="notFoundBody">
      <div class="icon">
        <img src="https://res.roompai.com/static/img/404TEST.png"/>
      </div>
      <div class="content">
        <div class="contentRow">{{$t('notFoundTextOne')}}</div>
        <div class="contentRow">
          {{$t('notFoundTextTwoLeft')}}
          <!-- <a href="/question/contactUs?" style="color: #5392F9;font-size: 14px;cursor: pointer;text-decoration:none">{{$t('contactUs')}}</a> -->
          <router-link :to="{name:'contactUs', params: {'querys': common.linkEncode({'source': source}, 'obj')}}" style="color: #5392F9;font-size: 16px;cursor: pointer;text-decoration:none">
            {{$t('contactUs')}}
          </router-link>
          {{$t('notFoundTextTwoRight')}}
        </div>
      </div>
    </div>
  </div>
  <publicFooter :languageSet="language"></publicFooter>
</el-container>
</template>

<script scoped>
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
export default {
  name: 'Home',
  components: {
    publicFooter,
    publicHeader
  },
  props: [],
  data () {
    return {
      startTime: null,
      language: this.common.languageSet(this),
      currency: this.common.currencySet(this),
      source: 'roompai'
    }
  },
  beforeCreate () {
  },
  created: function () {
  },
  mounted: function () {
    var source = this.common.linkQuerys.source
    // 过期时间 5个小时
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
      var sourceExpiresAt = Date.now() + 3600000 * 5
      localStorage.setItem('source', this.source)
      localStorage.setItem('sourceExpiresAt', sourceExpiresAt)
    } else {
      localStorage.removeItem('source')
      localStorage.removeItem('sourceExpiresAt')
    }
  },
  watch: {},
  beforeDestroy () {
  },
  methods: {
    hotelLanguage (language) {
      this.language = language
    }
  }
}
</script>
<style type="text/css" scoped>
 .notFoundBody {
   height: 65vh;
   display: grid;
   line-height: 25px;
   font-size: 18px;
   font-family: PingFangSC-Regular,PingFang SC,sans-serif;
   font-weight: 400;
   margin-top: 100px;
   justify-items: center;
   align-content: center;
 }
 .icon {
   display: flex;
   margin-bottom: 30px;
   justify-content: center;
   align-items: center;
 }
 .icon img {
   height: 100px;
   box-sizing: border-box;
   text-align: center;
 }

 .content {
   display: inline-block;
   font-style: normal;
   letter-spacing: 1px;
   color: #4F4C4C;
   margin-bottom: 30px;
   text-align: center;
 }

 .contentTitle {
   height: 31px;
   font-size: 22px;
   background-color: rgba(255, 255, 255, 0);
   box-sizing: border-box;
   font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
   color: #333333;
   text-align: center;
   line-height: normal;
   margin: 22px 0;
 }

 .contentRow {
   height: 22.5px;
   font-size: 16px;
   background-color: rgba(255, 255, 255, 0);
   box-sizing: border-box;
   font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
   color: #333333;
   text-align: center;
   line-height: normal;
   margin: 16px 0;
 }

 @media only screen and (max-width:1099px){
   .notFoundBody {
     width: 90%;
     height: 50vh;
     text-align: center;
     margin: 100px auto;
     line-height: 17px;
     font-size: 14px;
     font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
     font-weight: 400;
   }
   .content {
     width: 100%;
     display: inline-block;
     font-style: normal;
     font-size: 14px;
     letter-spacing: 1px;
     color: #4F4C4C;
     line-height: 30px;
     margin-bottom: 30px;
     text-align: left;
   }
 }
</style>



// WEBPACK FOOTER //
// src/components/TTPage.vue